import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function KpiCard({ label, value, sub, icon: Icon, accent, delta, className, testId }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "group relative bg-card border border-border rounded-sm p-5 transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-lg",
        className
      )}
    >
      <div className="flex items-start justify-between">
        <span className="eyebrow">{label}</span>
        {Icon && (
          <span className={cn("rounded-sm p-1.5", accent || "bg-secondary text-foreground")}>
            <Icon className="h-4 w-4" strokeWidth={2} />
          </span>
        )}
      </div>
      <div className="mt-3 font-display text-3xl font-bold tracking-tight tabular">{value}</div>
      {(sub || delta != null) && (
        <div className="mt-1 flex items-center gap-1.5 text-sm text-muted-foreground">
          {delta != null && (
            <span className={cn("inline-flex items-center gap-0.5 font-medium", delta >= 0 ? "text-emerald-600" : "text-red-600")}>
              {delta >= 0 ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}
              {Math.abs(delta)}%
            </span>
          )}
          {sub && <span>{sub}</span>}
        </div>
      )}
    </div>
  );
}
